import { createAction, props } from '@ngrx/store';

import { GalleryTab, GalleryView } from '../../interfaces';

export const selectTab = createAction('[GalleryView] Select Tab', props<{ tab: GalleryTab }>());
export const selectView = createAction('[GalleryView] Select View', props<{ view: GalleryView }>());
